import { useNavigate } from 'react-router-dom';
import type { PipelineStage } from '../../../types/dashboard';

const stagePath: Record<string, string> = {
  in_sawing: '/sawing',
  predrying: '/warehouses/predrying',
  in_drying: '/drying',
  sorting: '/warehouses/sorting',
  dry_stock: '/warehouses/dry',
  prep_shop: '/warehouses/prep-shop',
  in_processing: '/processing',
  blank_stock: '/warehouses/blanks',
};

/** Обсяг стадії з одним знаком — великі цифри читаються без «хвоста». */
export function stageValue(stage: PipelineStage): string {
  return parseFloat(stage.metric_value).toLocaleString('uk-UA', {
    minimumFractionDigits: stage.metric_unit === 'шт' ? 0 : 1,
    maximumFractionDigits: stage.metric_unit === 'шт' ? 0 : 1,
  });
}

export function PipelineFlow({ pipeline }: { pipeline: PipelineStage[] }) {
  const navigate = useNavigate();

  return (
    <div className="dash-card">
      <div className="dash-section-label" style={{ marginBottom: 14 }}>
        Виробничий ланцюг
      </div>
      <div className="dash-pipe">
        {pipeline.map((stage, i) => (
          <div key={stage.key} style={{ display: 'contents' }}>
            <div
              className={`dash-pipe-stage${stage.is_active ? ' is-active' : ''}`}
              onClick={() => {
                const path = stagePath[stage.key];
                if (path) navigate(path);
              }}
            >
              <div className="dash-pipe-title">{stage.title}</div>
              <div className="dash-pipe-value">
                {stageValue(stage)}
                <span className="dash-pipe-unit">{stage.metric_unit}</span>
              </div>
              {stage.secondary && <div className="dash-pipe-sub">{stage.secondary}</div>}
            </div>
            {i < pipeline.length - 1 && <div className="dash-pipe-arrow">→</div>}
          </div>
        ))}
      </div>
    </div>
  );
}
